import { nextTick, ref, VNode } from 'vue'

export type ConfirmServiceTypeType = 'confirm' | 'save' | 'edit' | 'delete' | 'discard'

type paramsType = {
    header?: string,
    type?: ConfirmServiceTypeType,
    message?: string
    descriptionIcon?: string
    renderContent?: VNode
}

type ConfirmServiceType = {
    open: boolean,
    header: string
    type: string
    message: string
    descriptionIcon: string
    renderContent: VNode | undefined
    openModal: (params: paramsType) => void
    closeModal: () => void
    onClose?: () => void
    onConfirm?: () => void
}

class ConfirmServiceClass {
    open = false
    header = ''
    type = 'confirm'
    message = ''
    descriptionIcon = ''
    renderContent: VNode | undefined

    openModal (params: paramsType) {
        this.header = params.header || ''
        this.type = params.type || 'confirm'
        this.message = params.message || ''
        this.descriptionIcon = params.descriptionIcon || ''
        this.renderContent = params.renderContent || undefined
        this.open = true
    }
    closeModal () {
        //console.log('CLOSE')
        this.open = false
    }
    onClose () {
        //
    }
    onConfirm () {
        //
    }
}

const service = new ConfirmServiceClass()

export const confirmModalState = ref<ConfirmServiceType>(service)

const useConfirmModal = (params: paramsType): Promise<boolean>  => {
    return new Promise((resolve, reject) => {
        try {
            confirmModalState.value.openModal(params)

            confirmModalState.value.onClose = () => {
                confirmModalState.value.closeModal()
                nextTick().then(() => {
                    resolve(false)
                })
            }
            confirmModalState.value.onConfirm = () => {
                confirmModalState.value.closeModal()
                nextTick().then(() => {
                    resolve(true)
                })
            }
        } catch (err) {
            reject(err)
        }
    })
}

export default useConfirmModal
